module.exports = __webpack_public_path__ + "img/zhou.99c79ea4.jpg";